import { Zap } from 'lucide-react';
import { motion } from 'motion/react';

interface ExpressBadgeProps {
  variant?: 'default' | 'large';
  animate?: boolean;
}

export function ExpressBadge({
  variant = 'default',
  animate = true,
}: ExpressBadgeProps) {
  const isLarge = variant === 'large';

  return (
    <motion.div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f3ebff',
        border: '1px solid rgba(107, 52, 191, 0.3)',
        borderRadius: '9999px',
        paddingLeft: isLarge ? '10px' : '8px',
        paddingRight: isLarge ? '10px' : '8px',
        paddingTop: isLarge ? '6px' : '3px',
        paddingBottom: isLarge ? '6px' : '3px',
        minHeight: isLarge ? '32px' : '22px',
        gap: isLarge ? '10px' : '8px',
        flexShrink: 0,
      }}
      initial={animate ? { scale: 0.9, opacity: 0 } : undefined}
      animate={animate ? { scale: 1, opacity: 1 } : undefined}
      transition={
        animate
          ? {
              type: 'spring',
              stiffness: 500,
              damping: 20,
            }
          : undefined
      }
    >
      <Zap
        className={isLarge ? 'w-4 h-4' : 'w-3.5 h-3.5'}
        style={{
          color: '#6b34bf',
          fill: '#6b34bf',
          width: isLarge ? '16px' : '14px',
          height: isLarge ? '16px' : '14px',
        }}
      />
      <span
        style={{
          fontSize: isLarge ? 'var(--text-sm)' : 'var(--text-xs)',
          fontWeight: 'var(--font-weight-medium)',
          color: '#6b34bf',
          lineHeight: 'normal',
        }}
      >
        Express
      </span>
    </motion.div>
  );
}
